/* eslint-disable no-return-assign */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import * as c from '../../constant';

function RevenuePreviewModal({ id, getPreviewLink, previewLink }) {
  const setModal = useContext(ModalContext);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getPreviewLink(id, {bearer_token: token, email: _.get(authProfile, 'email')})
  }, [])

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Statement of Account"
                  src={_.get(previewLink, 'res.pre_signed_file')}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          &nbsp;
          <button
            type="button"
            onClick={closeModal}
            className="btn btn-dark "
          >
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

RevenuePreviewModal.propTypes = {
  getPreviewLink: PropTypes.instanceOf(Function).isRequired,
  previewLink: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  previewLink: _.get(api, `${c.GET_PREVIEW_LINK}`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(RevenuePreviewModal);
